var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qna-button-show"},[_c('aha-antd-button',{attrs:{"block":"","size":"lg","variant":"secondary"},on:{"click":function($event){return _vm.showqna()}}},[_c('span',[_vm._v(_vm._s(_vm.$t("askQuestionButton")))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }